import { useQuery } from "@tanstack/react-query";

import { getReportingFinance } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { REPORTING_QUERY_KEYS } from "./queryKeys";

export function useReportingFinanceQuery() {
  return useQuery({
    queryKey: REPORTING_QUERY_KEYS.finance(),
    queryFn: processResponse(() => getReportingFinance()),
    staleTime: 5 * 60 * 1000,
  });
}
